// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".unassigned-full-name[data-v-d34138ee]{color:#999}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/partials/FobLIstItem.vue"],"names":[],"mappings":"AACA,uCACE,UAAF","sourcesContent":["\n.unassigned-full-name {\n  color: #999999\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
